import { Component} from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
// import { GeneralService } from '../../services/general.service';
import {AuthService} from '../app/services/auth.service';
import { GlobalStorageService } from './services/GlobalStorage.service';
import { environment } from 'environments/environment';
import { APP_CONFIG } from './services/app.config';
import { setLogLevel } from 'firebase/firestore';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(
    private AngularFirestore:AngularFirestore,
    private globalStorage: GlobalStorageService
  ) { 
    // setLogLevel('debug');

    this.globalStorage.setEncryptionKey(APP_CONFIG.storageKey);

  const DbName=  localStorage.getItem('DbName')
console.log(DbName)
if(DbName){
  this.AngularFirestore.firestore['_databaseId'].database=DbName
  
}
  }
  
}
